import {
  BorderBox,
  Corner,
  FullContainer,
  InnerContainer,
  Overlay
} from './Finder.styles'

type FinderProps = {
  borderColor?: string
}

const Finder = ({ borderColor = '#006bff' }: FinderProps) => {
  return (
    <FullContainer aria-label='Camera Finder'>
      <InnerContainer>
        <Overlay>
          <BorderBox>
            <Corner
              data-testid='corner-top-left'
              $borderColor={borderColor}
              $position='top-left'
            />
            <Corner
              data-testid='corner-top-right'
              $borderColor={borderColor}
              $position='top-right'
            />
            <Corner
              data-testid='corner-bottom-left'
              $borderColor={borderColor}
              $position='bottom-left'
            />
            <Corner
              data-testid='corner-bottom-right'
              $borderColor={borderColor}
              $position='bottom-right'
            />
          </BorderBox>
        </Overlay>
      </InnerContainer>
    </FullContainer>
  )
}

export default Finder
